module.exports = __webpack_public_path__ + "img/Kafel-logo.684e924a.svg";